import React from "react";

const HealthPage = () => {
  return (
    <div
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: `translate(-50%, -50%)`,
      }}
    >
      <h1 style={{ fontSize: "3rem" }}>I am healthy 💪</h1>
    </div>
  );
};

export default HealthPage;
